<div [ngClass]="'ui-overlaypanel ui-widget ui-widget-content ui-corner-all ui-shadow card border-default bg-white pt-2 box-shadow'"
  [ngStyle]="style" [class]="styleClass" [style.display]="visible ? 'block' : 'none'" style="z-index: 3;" (click)="onPanelClick($event)"
  [@panelState]="visible ? 'visible' : 'hidden'">
  <div class="ui-overlaypanel-content">
    <ng-content></ng-content>
  </div>
  <a href="#" *ngIf="showCloseIcon" class="ui-overlaypanel-close ui-state-default" (click)="onCloseClick($event)">
    <span class="fa fa-fw fa-close"></span>
  </a>
</div>